export default "__VITE_ASSET__CcODcEsY__"